module.exports = __webpack_public_path__ + "img/evaluation.844abd16.png";